module.exports = __webpack_public_path__ + "static/img/img-61.897a881.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-61.png
// module id = cE8j
// module chunks = 0